import { derived, get, readable } from 'svelte/store';
import { getAppConfig } from '../../../common/config/app-config';
import {
  checkForMegaSaleProduct,
  getFreeGiftLength,
  getJoodDayTheme,
  getOfferLabel,
  getProductTags,
  getTasheelInfo,
} from '../../../common/util';
import { getBottomTags } from '../../brand/services/brand-data-services';

const { lang } = getAppConfig();
const language = lang.substr(0, 1).toUpperCase() + lang.substr(1);

export function productTileStore(unbxdProductObj) {
  const productStore = readable(unbxdProductObj);
  const productTileTitleData = derived(productStore, getTitleSection);
  const productTileImageData = derived(productStore, getImageSection);
  const productTileRatingData = derived(productStore, getRatingReviewSection);
  const productTilePriceData = derived(productStore, getPriceSection);
  const productTileOfferLabelsData = derived(productStore, getOfferLabelsSection);
  const productTileBottomTagsData = derived(productStore, getBottomTagsSection);
  const productTileHeaderData = derived(productStore, getHeaderSection);

  return {
    subscribe: productStore.subscribe,
    productTileTitleData: get(productTileTitleData),
    productTileImageData: get(productTileImageData),
    productTileRatingData: get(productTileRatingData),
    productTilePriceData: get(productTilePriceData),
    productTileOfferLabelsData: get(productTileOfferLabelsData),
    productTileBottomTagsData: get(productTileBottomTagsData),
    productTileHeaderData: get(productTileHeaderData),
  };
}

function getTitleSection($ps, set) {
  set({
    brandName: $ps?.brandName ?? $ps[`brandName${language}`] ?? $ps[`brand${language}`],
    name: $ps?.name ? $ps.name : $ps[`name${language}`],
  });
}
function getImageSection($ps, set) {
  set({
    amplienceProductBaseUrl: `https:${$ps?.amplienceProductBaseUrl}`,
  });
}
function getRatingReviewSection($ps, set) {
  set({
    rating: $ps?.rating,
    reviews: $ps?.numberOfReviews,
  });
}
function getPriceSection($ps, set) {
  const discountPrice = $ps?.discountPrice;
  const price = $ps?.price;
  const joodTheme = getJoodDayTheme($ps);
  const goldPrice = $ps?.vipPrimePrice
    ? $ps.vipPrimePrice
    : $ps?.productVipPrimeData?.primePrice?.formattedValue
      ? $ps?.productVipPrimeData?.primePrice?.formattedValue
      : null;
  const bluePrice = $ps?.basicPrimePrice
    ? $ps.basicPrimePrice
    : $ps?.productBasicPrimeData?.primePrice?.formattedValue
      ? $ps?.productBasicPrimeData?.primePrice?.formattedValue
      : null;
  set({
    price:
      discountPrice?.formattedValue && discountPrice.formattedValue > 0
        ? discountPrice.formattedValue
        : price?.formattedValue || price,
    basicPrimePrice: bluePrice,
    vipPrimePrice: goldPrice,
    wasPrice: $ps?.wasPrice,
    priceValueTasheel: { ...getTasheelInfo($ps) },
    isJoodDayFlag: joodTheme?.joodType,
    joodDayTheme: joodTheme?.borderColor,
    joodDayRemainingQuantity: $ps?.joodDayRemainingQuantity || 0,
    tacticalBasicPromo: $ps?.tacticalBasicPromo
      ? $ps.tacticalBasicPromo
      : $ps?.productBasicPrimeData?.tacticalPromo
        ? $ps?.productBasicPrimeData?.tacticalPromo
        : false,
    tacticalVipPromo: $ps?.tacticalVipPromo
      ? $ps.tacticalVipPromo
      : $ps?.productVipPrimeData?.tacticalPromo
        ? $ps?.productVipPrimeData?.tacticalPromo
        : false,
    tacticalVipPrimePrice: $ps?.tacticalVipPrimePrice
      ? $ps?.tacticalVipPrimePrice
      : $ps?.productVipPrimeData?.tacticalPrice?.formattedValue,
    tacticalBasicPrimePrice: $ps?.tacticalBasicPrimePrice
      ? $ps?.tacticalBasicPrimePrice
      : $ps?.productBasicPrimeData?.tacticalPrice?.formattedValue,
    hasCashBack: $ps?.hasCashBack ? $ps.hasCashBack : false,
    afterCashBackPrice: $ps?.aftreCashBackPrice?.formattedValue ? $ps?.aftreCashBackPrice?.formattedValue : null,
    cashBackPrice: $ps?.cashBackPrice ? $ps.cashBackPrice : null,
    priceValueDiscountPercentageFlag: $ps?.priceValueDiscountPercentageFlag,
    plpEligibleForTamara: $ps?.plpEligibleForTamara,
    plpEligibleForTamaraBlue: $ps?.plpEligibleForTamaraBlue,
    plpEligibleForTamaraGold: $ps?.plpEligibleForTamaraGold,
    plpEligibleForTabby: $ps?.plpEligibleForTabby,
    plpEligibleForFlooss: $ps?.plpEligibleForFlooss,
    eligibleForFlooss: $ps?.eligibleForFlooss,
    percentageDiscount: $ps?.percentageDiscount,
    endDateJoodDay: $ps?.endDateJoodDay || null,
    floossSupportedInstalments: $ps?.floossSupportedInstalments
      ? $ps?.floossSupportedInstalments
      : $ps?.floossDetails?.installments
        ? $ps?.floossDetails?.installments
        : null,
    smartFirstPrimePrice: $ps?.smartFirstPrimePrice,
    smartRepeatingPrimePrice: $ps?.smartRepeatingPrimePrice,
    tacticalSmartFirstPromo: $ps?.tacticalSmartFirstPromo,
    tacticalSmartRepeatingPromo: $ps?.tacticalSmartRepeatingPromo,
    tacticalSmartFirstPrimePrice: $ps?.tacticalSmartFirstPrimePrice,
    tacticalSmartRepeatingPrimePrice: $ps?.tacticalSmartRepeatingPrimePrice,
    smartFirstWalletCredits: $ps?.smartFirstWalletCredits || $ps?.productSmartPrimeData?.totalPrimeDiscount?.value,
    smartRepeatingWalletCredits:
      $ps?.smartRepeatingWalletCredits || $ps?.productSmartPrimeData?.totalPrimeDiscount?.value,
    basicWalletCredits: $ps?.basicWalletCredits || $ps?.productBasicPrimeData?.totalPrimeDiscount?.value,
    vipWalletCredits: $ps?.vipWalletCredits || $ps?.productVipPrimeData?.totalPrimeDiscount?.value,
  });
}

function getOfferLabelsSection($ps, set) {
  set({
    offersLabel: $ps?.offersCount || $ps?.offersLabel ? getOfferLabel($ps?.offersCount || $ps?.offersLabel) : null,
    freeGiftCount: $ps?.freeGiftCount ? $ps.freeGiftCount : getFreeGiftLength($ps),
  });
}

function getBottomTagsSection($ps, set) {
  const productTags = getProductTags($ps);
  set({
    tagsData: getBottomTags($ps),
    isMegasaleProduct: productTags?.length ? checkForMegaSaleProduct(productTags) : [],
  });
}

function getHeaderSection($ps, set) {
  set({
    product: $ps,
    productTags: getProductTags($ps),
    productCode: $ps?.code,
  });
}
